import * as actions from './master/actions'
import * as mutations from './master/mutations'
import * as getters from './master/getters'

//import { menuProperties } from './master/properties'

const state = {
    db: null,
    refCompany: null
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/master.js